gsap.registerPlugin(ScrollTrigger, Observer, SplitText, ScrollToPlugin);

function onLoad(noanim) {

    menuToggle();
    swiperCursor();
    heroHome();
    heroAbout();
    heroProject(noanim);
    initGallery();
    handleScroll();
    flagAnimation();
    banner();
    bannerProject();
    blogPost();
    setTimeout(() => {
        postQw();
        swiperFilter();
    },300);
    imagePath();
    carouselPath();
    if(document.querySelector('.c-hero')) {
        moveSquareHero();
    }
    setTimeout(newGallery, 1000);
    if(document.querySelector('.c-esp')) {
        animCaracteristicas(document.querySelectorAll('.c-esp'))
    }
    // scrollTo();
    // initSwiperSpecs();

    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    })
    let selector = document.querySelectorAll('[data-anim]');
    if(!document.querySelector('.no-anim')) {
        selector.forEach((element, index) => {

            let animName = element.getAttribute("data-anim")
            console.log(element, element.parentElement,)
            switch (animName) {
                case "fade-in-up-text":
                    const els = Array.from(element.children);

                    gsap.set(els, {
                        y: 40,
                        autoAlpha: 0,
                    });
                    gsap.to(element,{autoAlpha:1, duration:0.1})
                    const elText = gsap.fromTo(els, {
                        y: 40,
                        autoAlpha: 0,
                    }, {
                        autoAlpha: 1,
                        y: 0,
                        ease: "power4.out",
                        stagger: 0.2,
                        duration: 0.8,
                    });

                    ScrollTrigger.create({
                        trigger: element,
                        start: "50% bottom-=80px", 
                        animation: elText, 
                        // markers: true,
                    });

                    break;
                case "maskup-text":
                    let split = new SplitText(element.querySelectorAll('.js-split, .js-split > *'), {
                        type: "lines",
                    });
                
                    split.lines.forEach(line => {
                        const wrapper = document.createElement('span');
                        wrapper.classList.add('line-wrapper');
                        line.parentNode.insertBefore(wrapper, line);
                        wrapper.appendChild(line);
                    });
                    gsap.to(element, {autoAlpha:1})
                
                    const splitTextAnimation = gsap.fromTo(
                        split.lines, 
                        {
                            yPercent: 120, 
                            autoAlpha: 0, 
                        }, 
                        {
                            yPercent: 0,   
                            autoAlpha: 1,  
                            ease: "power4.out",
                            stagger: 0.2,  
                            duration: 0.8,
                        }
                    );
                
                    // Configura el ScrollTrigger
                    ScrollTrigger.create({
                        trigger: element,
                        start: "top bottom-=80px", 
                        // markers: true,               
                        toggleActions: "play none none none",
                        animation: splitTextAnimation, 
                    });

                    break;
                case "fade-in-up":
                    let fadeInUp = gsap.to(element, {
                        autoAlpha: 1,
                        ease: "power2.inOut",
                        duration: 2,
                        y: 0
                    });
                    // gsap.to(element, {autoAlpha:1})

                    ScrollTrigger.create({
                        trigger: element,
                        start: "top bottom-=80px", 
                        
                        toggleActions: "play none none none",
                        animation: fadeInUp,
                        // markers: true
                    });

                    break;
                case "to-up":
                    // console.log('to-up')
                    let goUp = gsap.timeline();
                    // console.log('este', element.querySelector('.curtain'))
                    gsap.set(element.children[1], { top: '100%', autoAlpha: 0 })
                    goUp
                        .fromTo(element.querySelector('.curtain'), { bottom: '-100%' }, { bottom: 0, ease: "expo.inOut", duration: 1.1 })
                        .fromTo(element.querySelector('img'), { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 })
                        .to(element.querySelector('.curtain'), { bottom: "100%", ease: "expo.inOut", duration: 1.1 })
                    if (element.children[1]) {
                        goUp.to(element.children[1], { top: "0", autoAlpha: 1, ease: "expo.inOut", duration: 1.1 }, '<')
                    }
                    ScrollTrigger.create({
                        trigger: element,
                        start: "top bottom-=80px", 
                        
                        toggleActions: "play none none none",
                        animation: goUp,
                        // markers: true
                    });

                    break;
                default:

                    // no animation F

                    break;
            }

        });
    }
}
if(document.querySelector('.swiper-specs')) {
    document.querySelectorAll('.swiper-specs').forEach(spec => {
        var swiper = new Swiper(spec, {
            slidesPerView: "auto",
            spaceBetween: 16,
            mousewheel: {
                releaseOnEdges: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
    })
    // CAMBIO DE IMAGENES EN EL DROPDOWN MOVIL
    document.querySelectorAll('.swiper-specs input').forEach(radio => {
        const container = radio.closest('.c-specs_cont'); 
        const button = container.querySelector('.btn-secondary'); 

        radio.addEventListener('change', (event) => {
            if(radio.nextElementSibling.querySelector('img')) {
                button.querySelector('img').src = radio.nextElementSibling.querySelector('img').src
            }
        });

    })
}


// const materialButton = document.getElementById('materialButton');
// const materialImage = document.getElementById('materialImage');

// // Escuchar cambios en los inputs de tipo radio
// document.querySelectorAll('input[name="material"]').forEach((radio) => {
//   radio.addEventListener('change', (event) => {
//     // Cambiar la imagen en el botón según el valor del radio seleccionado
//     materialImage.src = event.target.value;
//   });
// });

function delay(n) {
    n = n || 2000;
    return new Promise(done => {
        setTimeout(() => {
            done();
        }, n);
    })
}

function proyectPageTransitionL(data) {
    let height = '715px'
    let preHeight = '60vh'
    let preWidth = '60vw'
    let width = 'calc(100% - 4.375rem)'
    let top = '6.25rem'
    let right = '20vw'
    // AJUSTAR MEDIA QUERY
    if(window.matchMedia('(min-width: 740px) and (max-width: 992px)').matches) {
        height = '615px'
    } else if(window.matchMedia("(max-width: 740px)").matches) {
        height = '50vh';
        width= '100%';
        top = '3.75rem'
        preHeight = '50vh'
        preWidth = '100%'
        right = 0
    }
 gsap.set(data.trigger.querySelector('.qw__figure'), {
    position: 'fixed',
    width: data.trigger.querySelector('.qw__figure').offsetWidth,
    height: data.trigger.querySelector('.qw__figure').offsetHeight,
 })
 let tl = gsap.timeline({});
 data.trigger.querySelector('.qw__figure').classList.add('select')
    tl.to(data.trigger.querySelector('.qw__figure'), {
        width: width, right: 0, top: top, height: height,
        zIndex: 99999,
        // transformOrigin: 'center',
        duration:1.2,
        ease: 'power2.out',
    })
    // .to(data.trigger.querySelector('.qw__figure'), { right:0, top: top, duration: 1.5})
    // .to(data.trigger.querySelector('.qw__figure'), {height: '715px',width: 'calc(100% - 4.375rem)',transformOrigin: 'center', duration: 2})
    gsap.to(window, {scrollTo: 0, delay:0.5});
   
}
// function proyectPageTransitionE(data) {
//  console.log('soy la funcion de la transciion de entrada')

 
   
// }
function noticiasPageTransitionL(data) { 
    let img;
    console.log('estoy entrando')
    // let height = '715px'
    // let preHeight = '60vh'
    // let preWidth = '60vw'
    // let width = 'calc(100% - 4.375rem)'
    let top = '6.25rem'
    // let right = '20vw'
    // AJUSTAR MEDIA QUERY
    if(window.matchMedia("(max-width: 740px)").matches) {
        // height = '50vh';
        // width= '100%';
        top = '3.75rem'
        // preHeight = '50vh'
        // preWidth = '100%'
        // right = 0
    }
    // console.log(data.trigger)
    document.querySelectorAll('.new-image').forEach(image => {
        if(image.id === data.trigger.parentElement.dataset.new) {
            img = image
        }
    })
    console.log(img)
    document.querySelector('.c-project__item-right').style.transform = 'none'; // Anula el transform heredado del CSS
    // gsap.to('.c-project__item-right', {
    //     clearProps: 'transform',
    //     duration:0.1
    // })
    gsap.set(img, {
        position: 'fixed',
        width: img.offsetWidth,
        height: img.offsetHeight,
     })
    gsap.to(img, {
        width: '50vw', left: 0, top:top , height: '100dvh',
        zIndex: 99999,
        // transformOrigin: 'center',
        duration:1.2,
        ease: 'power2.out',
    })
}

// barba.hooks.after(() => {
//     // console.log('no estoy segura de que hacer')
//     // if (Cookiebot.consent.statistics) {
//         gtag('event', 'page_view', {
//             'page_title': document.title,
//             'page_location': location.href,
//             'page_path': location.pathname,
//         });
//     // }
// });

// barba.hooks.afterLeave((data) => {
//     // console.log('afterleave')
//     setTimeout(() => {
//         // console.log('aqio estoy entrando?')
//         onLoad("noanim");
//     }, 200);
//     let triggers = ScrollTrigger.getAll();
//     triggers.forEach(function (trigger) {
//         trigger.kill();
//     });
// });

// barba.hooks.afterEnter((data) => {
   
// });

// barba.init({
//     sync: true,
//     preventRunning: true,
//     transitions: [
//         {
//         name: 'projects-transition',
//         beforeEnter({ next }) {
//           if (next.url.path !== document.location.pathname) {
//             window.history.pushState({}, '', next.url.path);
//           }
//         }
//       },{
//         from: {
//             custom: ({ trigger }) => {
//                 return trigger.classList && trigger.classList.contains('qw__wrapper');
//             },
//         },
        
//         async leave(data) {
//             document.body.classList.add('no-scroll')
//             const done = this.async();

//             proyectPageTransitionL(data);
//             await delay(1400);
//             // console.log('me voy?')
//             done();
//         },
//         async after(data) {
//             // console.log('entro?')
//             gsap.set('.c-hero-project__figure', {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'})
//             gsap.set('.c-hero-project__image', {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'})
//             // document.querySelector('.c-hero-project__figure').style.clipPath ='polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
//             document.body.classList.remove('no-scroll')
//             gsap.to(window, {scrollTo: 0,});

//             // onLoad();
//             const done = this.async();

//             // proyectPageTransitionE();
//             // await delay(2100);
//             done();

//         }
//     }, {
//         name: 'noticias-transition',
//         beforeEnter({ next }) {
//           if (next.url.path !== document.location.pathname) {
//             window.history.pushState({}, '', next.url.path);
//           }
//         }
//       },{
//         from: {
//             custom: ({ trigger }) => {
//                 // console.log(trigger)
//                 return trigger.classList && trigger.classList.contains('link-notiticas');
//             },
//         },
        
//         async leave(data) {
//             console.log('adeu')
//             document.body.classList.add('no-scroll')
//             const done = this.async();

//             noticiasPageTransitionL(data);
//             await delay(1400);
//             done();
//         },
//         async after(data) {
//             console.log('holis')
            
//             document.body.classList.remove('no-scroll')
//             gsap.to(window, {scrollTo: 0,});
//             const done = this.async();

//             done();

//             // console.log('entro?')
           

//         }
//     }]
// })
window.addEventListener('popstate', function () {
    window.location.reload();
  });


/*-------------------------------------------------------------------------------
## open/close menu
-------------------------------------------------------------------------------*/

function menuToggle() {

    const menuAnimation = new gsap.timeline({
        ease: "power2.inOut"
    });

    menuAnimation
        // .to(bodyElement, { overflow: 'hidden' })
        .to('#main', { autoAlpha: 0 }, '<')
        .to('.c-header', { autoAlpha: 0 }, '<')
        .to('.c-header-alt', { autoAlpha: 0 }, '<')
        .to('.c-header__dropdown', { autoAlpha: 1 }, '<')
        .fromTo('.c-header__wrapper-overlay .c-header__overlay', { height: 0 }, { height: '100%', stagger: 0.2 }, '<')
        .to('.c-header__content .row', { autoAlpha: 1, stagger: 0.2 })

    menuAnimation.pause();

    const openMenu = document.getElementById('js-open-menu');
    const closeMenu = document.getElementById('js-close-menu');

    openMenu.addEventListener('click', function () {

        document.body.classList.add('overflow-hidden')
        menuAnimation.play();
        document.querySelector('.c-header__dropdown .container').style.overflow = 'auto'
    });

    closeMenu.addEventListener('click', function () {
        document.querySelector('.c-header__dropdown .container').style.overflow = 'hidden';
        menuAnimation.reverse().then(() => {
            document.querySelector('.c-header__dropdown .container').style.overflow = '';
            document.body.classList.remove('overflow-hidden');
        });
    });

}

/*-------------------------------------------------------------------------------
## swiper gallery (custom cursor)
-------------------------------------------------------------------------------*/

function swiperCursor() {

    let touch = false;

    if (document.querySelector('html').classList.contains('touchevents')) {
        touch = true
    }

    let swiperParent1 = document.querySelectorAll('.parent1');

    if (swiperParent1) {
        swiperParent1.forEach(swiper => {
            let mySwiper = new Swiper(swiper, {
                loop: true,
                allowTouchMove: false,
                effect: 'creative',
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: [0, 0, -1],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                pagination: {
                    el: swiper.querySelector('.swiper-pagination-bullets'),
                    type: 'bullets',
                    clickable: true,
                },
                navigation: {
                    nextEl: swiper.querySelector('.c-carousel__button-next'),
                    prevEl: swiper.querySelector('.c-carousel__button-prev'),
                },
                on: {
                    slideChange: function () {
                        let current = mySwiper.realIndex + 1;
                        let total = mySwiper.slides.length; // because of loop
                        swiper.querySelector('.swiper-pagination-fraction').innerHTML = `${current} / ${total}`;
                    },
                },
            });

            // Set initial fraction pagination
            let initialCurrent = mySwiper.realIndex + 1;
            let initialTotal = mySwiper.slides.length;
            swiper.querySelector('.swiper-pagination-fraction').innerHTML = `${initialCurrent} / ${initialTotal}`;

            const follower = swiper.querySelector('.follower');

            if (!touch) {
                gsap.set(follower, {
                    xPercent: -50,
                    yPercent: -50,
                });

                init(swiper);
            }
        });
    }



    function onMouseEnter(el) {
        gsap.to(el.querySelector('.follower'), 0.3, {
            autoAlpha: 1,
            scale: 1,
        })
    }

    function onMouseMove(el, ev) {
        const mitadAnchoDiv = el.offsetWidth / 2;
        const posicionXCursor = ev.clientX - el.getBoundingClientRect().left;

        if (posicionXCursor < mitadAnchoDiv) {
            gsap.to(el.querySelector('.follower'), 0.3, {
                rotation: 0
            });
        } else {
            gsap.to(el.querySelector('.follower'), 0.3, {
                rotation: 180
            });
        }

        gsap.to(el.querySelector('.follower'), 0, {
            x: ev.offsetX,
            y: ev.offsetY,
        })
    }

    function onMouseLeave(el) {

        gsap.to(el.querySelector('.follower'), 0.3, {
            autoAlpha: 0, scale: 0.1
        })
    }

    function onMouseClick(el, ev) {
        const mitadAnchoDiv = el.offsetWidth / 2;
        const posicionXCursor = ev.clientX - el.getBoundingClientRect().left;
        if (posicionXCursor < mitadAnchoDiv) {
            el.querySelector('.c-carousel__button-prev').click();
        } else {
            el.querySelector('.c-carousel__button-next').click();
        }
    }

    function init(el) {


        el.addEventListener('click', (ev) => {
            onMouseClick(el, ev)
        })
        el.addEventListener('mousemove', (ev) => {
            onMouseMove(el, ev)
        })
        el.addEventListener('mouseleave', () => {
            onMouseLeave(el)
        })
        el.addEventListener('mouseenter', () => {
            onMouseEnter(el)
        })

    };
}
/*-------------------------------------------------------------------------------
## leve animacion scroll cuadrado c-hero
-------------------------------------------------------------------------------*/
function moveSquareHero () {
    const parallaxBox = document.querySelector('.c-hero .square');
    gsap.to('.square', { 
        y: -60, 
        scrollTrigger: {
            trigger: '.c-hero', 
            start: "top top", 
            // markers: true,
            // scrub: true, 
        }
    });
}
/*-------------------------------------------------------------------------------
## c-hero (HomePage, Product-view)
-------------------------------------------------------------------------------*/

function heroHome() {

    const heroItem = gsap.utils.toArray(".c-hero");

    heroItem.forEach((element, index) => {

        const figure = element.querySelector(".c-hero__figure");
        const image = element.querySelector(".c-hero__image");
        const inner = element.querySelector(".c-hero__inner");
        const icon = element.querySelector(".c-hero__icon");
        const triangle = element.querySelector(".c-hero__triangle");

        let split = new SplitText(
            element.querySelectorAll('.js-split'), { type: "lines" }
        );

        split.lines.forEach(line => {
            const wrapper = document.createElement('span');
            wrapper.classList.add('line-wrapper');
            line.parentNode.insertBefore(wrapper, line);
            wrapper.appendChild(line);
        });

        let timeline = gsap.timeline({
            defaults: {
                duration: 1.4,
                ease: "power4.out",
            }
        });

        timeline.to([figure, image, inner], {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            stagger: 0.2
        })

        timeline.from(split.lines, {
            yPercent: 120,
            stagger: 0.15,
        })
        if (element.querySelector(".c-hero__icon")){
            timeline.fromTo(icon, {
                y: 200
            }, {
                autoAlpha: 1,
                y: 0
            }, "<")    
        }

        timeline.to(triangle, {
            y: 0,
        }, "<")

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
            
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}

/*-------------------------------------------------------------------------------
## c-hero-about
-------------------------------------------------------------------------------*/

function heroAbout() {

    const heroItem = gsap.utils.toArray(".c-hero-about");

    heroItem.forEach((element, index) => {

        const figure = element.querySelector(".c-hero-about__figure");
        const image = element.querySelector(".c-hero-about__image");
        const inner = element.querySelector(".c-hero-about__inner");
        const icon = element.querySelector(".c-hero-about__icon");
        const triangle = element.querySelector(".c-hero-about__triangle");

        let split = new SplitText(
            element.querySelectorAll('.js-split'), { type: "lines" }
        );

        split.lines.forEach(line => {
            const wrapper = document.createElement('span');
            wrapper.classList.add('line-wrapper');
            line.parentNode.insertBefore(wrapper, line);
            wrapper.appendChild(line);
        });

        let timeline = gsap.timeline({
            defaults: {
                duration: 1.4,
                ease: "power4.out",
            }
        });

        timeline.to([figure, image, inner], {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            stagger: 0.2
        })

        timeline.from(split.lines, {
            yPercent: 120,
            stagger: 0.15,
        })

        timeline.fromTo(icon, {
            y: 200
        }, {
            autoAlpha: 1,
            y: 0
        }, "<")

        timeline.to(triangle, {
            y: 0,
        }, "<")

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
    
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}

/*-------------------------------------------------------------------------------
## c-hero-project
-------------------------------------------------------------------------------*/

function heroProject(noanim) {
    console.log(noanim)
    const heroItem = gsap.utils.toArray(".c-hero-project");

    heroItem.forEach((element, index) => {

        const figure = element.querySelector(".c-hero-project__figure");
        const image = element.querySelector(".c-hero-project__image");
        const inner = element.querySelector(".c-hero-project__inner");
        const triangle = element.querySelector(".c-hero-project__triangle");

        let split = new SplitText(
            element.querySelectorAll('.js-split'), { type: "lines" }
        );

        split.lines.forEach(line => {
            const wrapper = document.createElement('span');
            wrapper.classList.add('line-wrapper');
            line.parentNode.insertBefore(wrapper, line);
            wrapper.appendChild(line);
        });

        let timeline = gsap.timeline({
            defaults: {
                duration: 1.4,
                ease: "power4.out",
            }
        });
        if(noanim) {
            timeline.to(inner, {
                clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                stagger: 0.2
            })
        } else {
            timeline.to([figure, image, inner], {
                clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                stagger: 0.2
            })
        }

        timeline.from(split.lines, {
            yPercent: 120,
            stagger: 0.15,
        })

        timeline.to(triangle, {
            y: 0,
        }, "<")

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
    
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}

/*-------------------------------------------------------------------------------
## lightGallery 
-------------------------------------------------------------------------------*/

function initGallery() {
    const gallery = document.querySelectorAll(".single-project");
    if (gallery.length === 0) {
        return;
    }

    gallery.forEach((element, index) => {
        lightGallery(element, {
            selector: ".c-image img",
            controls: true,
            counter: true,
            plugins: [lgAutoplay, lgFullscreen, lgThumbnail, lgZoom],
            preload:2,
            thumbnail: false,
        });
    });
}

/*-------------------------------------------------------------------------------
## hide header on scroll
-------------------------------------------------------------------------------*/

function handleScroll() {

    gsap.defaults({
        ease: "power4.out",
        duration: 0.6
    });

    const headerClass = ".js-header";
    const hiddenPosition = "-101%";
    const visiblePosition = "0";
    const topDisplay = 100;
    let lastScrollTop = 0;

    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", function () {
        let scrollTop = window.scrollY;

        if (scrollTop > topDisplay) {
            let direction = scrollTop > lastScrollTop ? hiddenPosition : visiblePosition;
               gsap.to(headerClass, { y: direction });
        }

        lastScrollTop = scrollTop;
    });
}

/*-------------------------------------------------------------------------------
## flag animation
-------------------------------------------------------------------------------*/

function flagAnimation() {

    gsap.defaults({
        ease: "power4.out",
        duration: 1.2
    });

    const images = gsap.utils.toArray(".c-flag");

    if (images.length === 0) {
        return;
    }

    images.forEach((element) => {

        const triangle = element.querySelector(".c-flag__triangle");
        const inner = element.querySelector(".c-flag__inner");

        const timeline = gsap.timeline();

        timeline
            .to(triangle, { top: 0 })
            .from(inner, { autoAlpha: 0 })

        ScrollTrigger.create({
            trigger: element,
            start: "top 60%",
            toggleActions: "play none none none",
            animation: timeline,
            // markers: true // Descomentar para ver los marcadores de ScrollTrigger
        });
    });
}

/*-------------------------------------------------------------------------------
## c-blog
-------------------------------------------------------------------------------*/

function blogPost() {

    const blogPost = gsap.utils.toArray(".c-blog");

    blogPost.forEach((element, index) => {

        postFigure = element.querySelector('.c-blog__figure')
        postImage = element.querySelector('.c-blog__img')
        postContent = element.querySelector('.c-blog__content')

        let timeline = gsap.timeline();

        timeline.from(postFigure, {
            duration: 1.5,
            clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
            ease: "power4.out",
        })

        timeline.from(postImage, {
            duration: 1.5,
            clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
            ease: "power4.out",
        }, .8)

        timeline.from(postContent, {
            autoAlpha: 0,
            ease: "power4.out",
        }, "<")

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
    
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}

/*-------------------------------------------------------------------------------
## c-qw
-------------------------------------------------------------------------------*/
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
}

function postQw() {
    console.log('he entrado')

    const qwPost = gsap.utils.toArray(".qw__wrapper");

    qwPost.forEach((element, index) => {
        // console.log(element)
        gsap.to(element, {autoAlpha:1})
        figure = element.querySelector('.qw__figure')
        image = element.querySelector('.qw__img')
        qwContent = element.querySelector('.qw__con')
        gsap.set(image, {clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',})
        gsap.set(figure, {clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',})

        let timeline = gsap.timeline();

        timeline.to(figure, {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            duration: 1.5,
            ease: "power4.out",
        });

        timeline.to(image,{
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            duration: 1.5,
            ease: "power4.out",
        });
        

        timeline.from(qwContent, {
            autoAlpha: 0,
            ease: "power4.out",
        }, "<")

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
    
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}



/*-------------------------------------------------------------------------------
## c-banner
-------------------------------------------------------------------------------*/

function banner() {
    const target = gsap.utils.toArray(".c-banner");

    target.forEach((element, index) => {

        const wrapper = element.querySelector(".c-banner__wrapper");
        const overlay = element.querySelector(".c-banner__overlay");
        const media = element.querySelector(".c-banner__media");
        const square = element.querySelector(".c-banner__square");

        gsap.to(element.querySelector('.c-banner__inner'),{autoAlpha:1})
        
        let split = new SplitText(
            element.querySelectorAll('.js-split'), { type: "lines" }
        );
            
        split.lines.forEach(line => {
            const wrapper = document.createElement('span');
            wrapper.classList.add('line-wrapper');
            line.parentNode.insertBefore(wrapper, line);
            wrapper.appendChild(line);
        });

        let timeline = gsap.timeline({
            defaults: {
                duration: .8,
                ease: "power4.out",
            }
        });

        timeline.to([wrapper, overlay], {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        })

        timeline.to([media, square], {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            stagger: 0.2
        }, "0.2")

        timeline.from(split.lines, {
            yPercent: 120,
            stagger: 0.3,
            // onComplete: function(){ console.log('finish') },
        }, "<")

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
    
            toggleActions: "play none none none",
            animation: timeline,
            // markers: true
        });
    });
}

/*-------------------------------------------------------------------------------
## banner project
-------------------------------------------------------------------------------*/

function bannerProject() {

    const target = gsap.utils.toArray(".c-banner-project");

    target.forEach((element, index) => {

        const figure = element.querySelector(".c-banner-project__figure");
        const image = element.querySelector(".c-banner-project__image");
        const inner = element.querySelector(".c-banner-project__inner");
        const triangle = element.querySelector(".c-banner-project__triangle");

        let split = new SplitText(
            element.querySelectorAll('.js-split'), { type: "lines" }
        );

        split.lines.forEach(line => {
            const wrapper = document.createElement('span');
            wrapper.classList.add('line-wrapper');
            line.parentNode.insertBefore(wrapper, line);
            wrapper.appendChild(line);
        });

        let timeline = gsap.timeline({
            defaults: {
                duration: 1.4,
                ease: "power4.out",
            }
        });

        timeline.to([figure, image, inner], {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            stagger: 0.2
        })

        timeline.from(split.lines, {
            yPercent: 120,
            stagger: 0.3,
        }, "<")

        timeline.to(triangle, {
            y: 0,
        }, "<")

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
    
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}

/*-------------------------------------------------------------------------------
## c-image
-------------------------------------------------------------------------------*/

function imagePath() {

    const target = gsap.utils.toArray(".c-image");

    target.forEach((element, index) => {

        const figure = element.querySelector(".c-image__figure");
        const image = element.querySelector(".c-image__image");
        const dot = element.querySelectorAll(".c-image__dot");

        let timeline = gsap.timeline();
        gsap.to(element, {autoAlpha:1})
        timeline.from([figure, image], {
            duration: 1.5,
            clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
            ease: "power4.out",
            stagger: 0.6
        })

        if (dot.length > 0) {
            timeline.to(dot, {
                autoAlpha: 1,
                stagger: 0.6
            });
        }

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
            
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}

/*-------------------------------------------------------------------------------
## c-carousel
-------------------------------------------------------------------------------*/

function carouselPath() {

    const target = gsap.utils.toArray(".c-carousel");

    target.forEach((element, index) => {
        gsap.to(element,{autoAlpha:1})
        const figure = element.querySelector(".c-carousel__wrapper");
        const image = element.querySelector(".c-carousel__swiper");

        let timeline = gsap.timeline();

        timeline.from([figure, image], {
            duration: 1.5,
            clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
            ease: "power4.out",
            stagger: 0.6
        })

        ScrollTrigger.create({
            trigger: element,
            start: "top bottom-=80px", 
    
            // markers: true,
            toggleActions: "play none none none",
            animation: timeline
        });
    });
}

/*-------------------------------------------------------------------------------
## c-filter (swiper)
-------------------------------------------------------------------------------*/

function swiperFilter() {

    var swiper = new Swiper(".c-filter__swiper", {
        slidesPerView: "auto",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        // freeMode: true,
    });
}

/*-------------------------------------------------------------------------------
## c-news
-------------------------------------------------------------------------------*/

const newGallery = () => {

    const newListItems = document.querySelectorAll('.c-project__info');
    const newImages = document.querySelectorAll('.new-image');

    newListItems.forEach(item => {

        item.addEventListener('mouseenter', () => {
            const newId = item.getAttribute('data-new');

            newImages.forEach(img => {
                img.classList.remove('active');
                if (img.id === newId) {
                    img.classList.add('active');
                }
            });
        });
    });

}

/*-------------------------------------------------------------------------------
## scroll-to

function scrollTo() {

    const target = document.querySelectorAll(".c-scrollspy__nav .c-scrollspy__nav-item .c-scrollspy__nav-link");

}
-------------------------------------------------------------------------------*/
// function initSwiperSpecs() {
//     const swiperContainers = document.querySelectorAll(".myspecs");
//     let count = 0;

//     swiperContainers.forEach(function (container) {
//         if (container) {
//             count++;
//             container.classList.add("swiper-container-" + count);
//             let swiperInstance = new Swiper(".swiper-container-" + count, {
//                 slidesPerView: "auto",
//                 spaceBetween: 8,
//             });
//         } else {
//             console.error("swiper container not found.");
//         }
//     });
// }

/*-------------------------------------------------------------------------------
## swiper panel
-------------------------------------------------------------------------------*/

if (document.querySelector('.swiper-panel')) {
    document.querySelectorAll('.swiper-panel').forEach((swiper) => {
        let animationFinished = true;
        let navs = swiper.querySelectorAll(".nav-swiper-panel .swiper-slide");
        let imgs = swiper.querySelectorAll(".imgs figure");
        let infos = swiper.querySelectorAll('.info-swiper')
        let currentIndex = -1;
        const progS = 100 / infos.length;

        // create an observer and disable it to start
        let intentObserver = Observer.create({
            type: "wheel,touch",
            wheelSpeed: -1, // to match mobile behavior, invert the wheel speed
            onDown: () => {
                if (animationFinished === true){
                    gotoPanel(currentIndex - 1);
                }
            },
            onUp: () => {
                if (animationFinished === true){
                    gotoPanel(currentIndex + 1);
                }
            },
            tolerance: 10,
            preventDefault: true,
            onPress: self => {
            // on touch devices like iOS, if we want to prevent scrolling, we must call preventDefault() on the touchstart (Observer doesn't do that because that would also prevent side-scrolling which is undesirable in most cases)
                ScrollTrigger.isTouch && self.event.preventDefault()
            }
        });
        
       
        intentObserver.disable();

        let preventScroll = Observer.create({
            preventDefault: true,
            type: "wheel,scroll",
            allowClicks: true,
            onEnable: self => self.savedScroll = self.scrollY(), // save the scroll position
            onChangeY: self => self.scrollY(self.savedScroll)    // refuse to scroll
        });
        preventScroll.disable();


        ScrollTrigger.create({
            trigger: swiper, 
            start: "top top", 
            //endTrigger: swiper,
            end: "+=100%",
            //end: () => `+=${window.innerHeight * infos.length}`, 
            pin: true, 
            invalidateOnRefresh: true,
            onEnter: (self) => {
                if (preventScroll.isEnabled === false) {
                    //self.scroll(self.start);
                    const y = swiper.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: y,
                        behavior: "smooth"
                    });
                    preventScroll.enable();
                    intentObserver.enable();
                    gotoPanel(currentIndex + 1);
                    console.log('trigger +1')

                }
            },
            onEnterBack: (self) => {
                if (preventScroll.isEnabled === false) {
                    const y = swiper.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: y,
                        behavior: "smooth"
                    });
                    preventScroll.enable();
                    intentObserver.enable();
                    gotoPanel(currentIndex - 1);
                    console.log('trigger -1')

                }
            }
            
        });
        /*ScrollTrigger.create({
            trigger: swiper,
            start: "top bottom-=80px", 
            toggleActions: "play none none none",
            onEnter: () => {
                if (!initswElem){
                    gotoPanel(0);
                    initswElem = true;
                }
            },
            invalidateOnRefresh: true
        });*/

        const swiperPanel = new Swiper(".nav-swiper-panel", {
            slidesPerView: "auto",
            slideToClickedSlide: true,
            on: {
                click() {
                    if (animationFinished){gotoPanel(this.clickedIndex)}
                }
            }
        });    

        gsap.set(imgs, { clipPath: "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)" });
        gsap.set(infos, { autoAlpha: 0 });

        let split = [];
        swiper.querySelectorAll('.info-swiper').forEach((el,i) => {
            split[i] = new SplitText(el.querySelectorAll('.text'), { type: "lines" });
            split[i].lines.forEach(line => {
                const wrapper = document.createElement('span');
                wrapper.classList.add('line-wrapper');
                line.parentNode.insertBefore(wrapper, line);
                wrapper.appendChild(line);
            });
        });

        function gotoPanel(index) {
            console.log(index)
            console.log(currentIndex, 'currentIndex')
            initswElem = false;
            gsap.set(navs, { pointerEvents: "none"});
            const animSp = gsap.timeline({
                onStart: () => {
                    animationFinished = false;
                },
                onComplete: () => {
                    animationFinished = true;
                }
            });

            // return to normal scroll if we're at the end or back up to the start
            if (
                (index === infos.length) ||
                (index === -1)
            ) {
                intentObserver.disable();
                preventScroll.disable();
                animationFinished = true;
                // now make it go 1px beyond in the correct direction so that it doesn't trigger onEnter/onEnterBack.
                preventScroll.scrollY(preventScroll.scrollY() + (index === infos.length ? 1 : -1));
                return;
            }

            if (index !== currentIndex) {
                if (currentIndex >= 0) {
                    animSp
                        .to(infos[currentIndex].querySelector('.infoimg__curtain'), { xPercent: 0, transformOrigin: 'left', duration: 0.4 })
                        .to(infos[currentIndex].querySelector('figure'), { clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)", duration: 0.4 })
                        .to(infos[currentIndex].querySelector('.infoimg__curtain'), { xPercent: 100, transformOrigin: 'left', duration: 0.4 })
                        .to(infos[currentIndex].querySelectorAll('.text'), { yPercent: 120, stagger: 0.1, duration: 0.3 }, '<')
                        .to(infos[currentIndex].querySelector('.btn'), { yPercent: 101, duration: 0.3 }, '<')
                        .to(infos[currentIndex].querySelector('.logo'), { yPercent: 100, duration: 0.3 }, '<')
                        .to(infos[currentIndex].querySelector('.layer-square'), { scaleX: 0, transformOrigin: 'left', duration: 0.6 }, '-=0.1')
                        .to(infos[currentIndex], { autoAlpha: 0, duration: 0 });
                }
            }

            if (currentIndex < 0){
                animSp
                .to(imgs[index], {
                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", duration: 1.2, ease: "power4.out"
                })
                .to(imgs[index].querySelector('.imgs__curtain'), {
                    clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)", duration: 0.4, ease: "power4.out"
                })
            } else if (index > currentIndex) {
                animSp
                .to(imgs[currentIndex], {
                    clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)", duration: 1.2, ease: "power4.out"
                },"-=1")
                .to(imgs[index], {
                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", duration: 1.2, ease: "power4.out"
                },"<")
                .to(imgs[index].querySelector('.imgs__curtain'), {
                    clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)", duration: 0.4, ease: "power4.out"
                }, '-=0.2')
                .to(imgs[currentIndex].querySelector('.imgs__curtain'), {
                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", duration: 0
                })
            } else if (index < currentIndex){
                animSp
                .to(imgs[currentIndex], {
                    clipPath: "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)", duration: 1.2, ease: "power4.out"
                },"-=1")
                .to(imgs[index], {
                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", duration: 1.2, ease: "power4.out"
                },"<")
                .to(imgs[index].querySelector('.imgs__curtain'), {
                    clipPath: "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)", duration: 0.4, ease: "power4.out"
                }, '-=0.2')
                .to(imgs[currentIndex].querySelector('.imgs__curtain'), {
                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", duration: 0
                })
            } else {
                return;
            }

            if (index !== currentIndex) {

                animSp
                .to(infos[index], { autoAlpha: 1, duration: 0 })
                .to(infos[index].querySelector('.infoimg__curtain'), {
                    xPercent: 0,
                    ease: "expo.inOut",
                    duration: .4
                },)
                .fromTo(infos[index].querySelector('figure'), {
                    clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)"
                }, {
                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", duration: 0.4
                })
                .to(infos[index].querySelector('.infoimg__curtain'), {
                    xPercent: -100,
                    ease: "expo.inOut",
                    duration: 0.2
                }, '-=0.2')
                .fromTo(infos[index].querySelector('.layer-square'), { 
                    scaleX: 0, transformOrigin: 'left' 
                }, { 
                    scaleX: 1, ease: "expo.inOut", duration: 0.4 
                }, '<')

                .fromTo(infos[index].querySelector('.logo'), { 
                    yPercent: 100 
                }, { 
                    yPercent: 0, duration: 0.4 
                }, '<')
                .fromTo(split[index].lines, {
                    yPercent: 120,
                }, {
                    yPercent: 0,
                    ease: "power4.out",
                    stagger: 0.1,
                    duration: 0.4
                }, '<')
                .to(infos[index].querySelectorAll('.text'), { 
                    yPercent: 0, stagger: 0.1, duration: 0.3
                })
                .fromTo(infos[index].querySelector('.btn'), {
                    yPercent: 120
                }, {
                    yPercent: 0, 
                    duration: 0.4,
                    onComplete:function(){
                        currentIndex = index;
                        animationFinished = true;
                    }
                }, '<')
                .set(navs, { pointerEvents: "auto", });
                changeSlide(index);
            }
            
        }

        function changeSlide(index) {
            swiperPanel.slides.forEach((el, i) => {
                el.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
                if (index == i) {
                    if (i == 0) {
                        el.nextElementSibling.classList.add('swiper-slide-next')
                    } else if (i === swiperPanel.slides.length - 1) {
                        el.previousElementSibling.classList.add('swiper-slide-prev')
                    } else {
                        el.previousElementSibling.classList.add('swiper-slide-prev')
                        el.nextElementSibling.classList.add('swiper-slide-next')
                    }
                    el.classList.add('swiper-slide-active')
                }
            })
        }

    })

}

////////////// FUNCTION ANIM CARACTERISTICAS ////////////
function animCaracteristicas(elements) {
    const elText = gsap.fromTo(elements, {
        y: 100,
        autoAlpha: 0,
    }, {
        autoAlpha: 1,
        y: 0,
        ease: "power4.out",
        stagger: 0.2,
        duration: 0.8,
    });
    elements.forEach(element => {
        ScrollTrigger.create({
            trigger: element,
            start: "50% bottom-=80px", 
            animation: elText, 
            // markers: true,
        });
    })
    // element.forEach(element ()=> {

    // })
}

window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
});

document.addEventListener("DOMContentLoaded", function () {
// console.log('hola caracola')


onLoad()
setTimeout(() => {
    if(document.querySelector('.pg-proyectos')) {
        document.querySelector('.c-filter').addEventListener('click', (event) => {
            if (event.target.classList.contains('form-check-input')) {
                setTimeout(() => {
                    postQw(); // Llama a tu función
                }, 300);
            }
        });
        document.querySelectorAll('.c-pagination__wrapper .btn').forEach(btn => {
            btn.addEventListener('click', ()=> {
                gsap.to(window, {scrollTo: 0});
                setTimeout(() => {
                    postQw(); // Llama a tu función
                }, 300);
            })
        })
    }
 }, 300);
   
});




/*-------------------------------------------------------------------------------
## artis2
-------------------------------------------------------------------------------*/

function calcHeightLine() {
    if (document.querySelector('.cont-time-line')) {
        if (window.matchMedia("(max-width: 567px)").matches) {
            let lastIndice = document.querySelectorAll('.js-date-timeline').length - 1
            let lastEl = document.querySelectorAll('.js-date-timeline')[lastIndice]
            let resta = document.querySelector('.cont-time-line .position-relative').offsetHeight - lastEl.offsetHeight
            document.querySelector(".cont-time-line .line").style.height = (resta + 40) + "px";
        } else {
            let lastIndice = document.querySelectorAll('.js-date-timeline').length - 1
            let lastEl = document.querySelectorAll('.js-date-timeline')[lastIndice]
            let resta = document.querySelector('.cont-time-line .position-relative').offsetHeight - lastEl.offsetHeight
            document.querySelector(".cont-time-line .line").style.height = (resta - 60) + "px";
        }
    }
}

if (document.querySelector(".cont-time-line .line")) {
    calcHeightLine();

    const dateElements = document.querySelectorAll(".js-date-timeline");
    if (dateElements.length) {
        ScrollTrigger.matchMedia({
            "(min-width: 576px)": function () {
                dateElements.forEach((dateElement, i) => {
                    /// POINT ///
                    gsap.from(dateElement.querySelector('.point'), {
                        duration: 0.2,
                        scale: 1.5,
                        backgroundColor: "#C4C4C466",
                        ease: 'power4.out',
                        scrollTrigger: {
                            trigger: dateElement.querySelector('.point'),
                            start: "top 95%",
                        }
                    })
                    if (i !== dateElements.length - 1) {
                        dateElement.querySelectorAll('.info p').forEach((p) => {
                            gsap.fromTo(p, {
                                opacity: 0,
                                y: 50,
                            }, {
                                opacity: 1,
                                y: 0,
                                delay: 0.5,
                                scrollTrigger: {
                                    trigger: dateElement.querySelector('.info'),
                                    start: " 80% top",
                                    ease: "power4.out",
                                }
                            })
                        })
                    }

                    /// INFOS ///
                    if (i === dateElements.length - 1) {
                        gsap.fromTo(dateElement.querySelector('.info'), {
                            opacity: 0,
                            y: 100,
                        }, {
                            opacity: 1,
                            y: 0,
                            scrollTrigger: {
                                trigger: dateElement.querySelector('.info'),
                                start: " 80% top",
                                ease: "power4.out",
                                onComplete: () => {
                                   console.log(this, dateElement)
                                }
                            }
                        })
                    }
                    if (dateElement.querySelector('.img')) {
                        gsap.fromTo(dateElement.querySelector('.img'), {
                            yPercent: 50,

                        }, {
                            yPercent: -100,
                            scrollTrigger: {
                                trigger: dateElement.querySelector('.cont-date'),
                                start: "top bottom-=80px", 
    
                                end: "bottom top",
                                // markers: true,
                                toggleActions: "play reverse play reverse",
                                scrub: 3,
                                ease: "power4.out"
                            }
                        })
                    }
                })
            },
            "(min-width: 980px)": function () {
                dateElements.forEach((dateElement, i) => {

                    if (dateElement.classList.contains('right')) {
                        gsap.fromTo(dateElement.querySelector('.info'), {
                            opacity: 0,
                            x: 50,
                        }, {
                            opacity: 1,
                            x: 0,
                            scrollTrigger: {
                                trigger: dateElement.querySelector('.info'),
                                start: " 80% top",
                                ease: "power4.out",
                            }
                        })
                    }
                    if (dateElement.classList.contains('left')) {
                        gsap.fromTo(dateElement.querySelector('.info'), {
                            opacity: 0,
                            x: -50,
                        }, {
                            opacity: 1,
                            x: 0,
                            scrollTrigger: {
                                trigger: dateElement.querySelector('.info'),
                                start: " 80% top",
                                ease: "power4.out",
                            }
                        })
                    }
                })
            }
        })
    }
}

if (document.querySelector('.cont-client')) {
    const clients = document.querySelectorAll('.clients');
    const maxClientWidth = Math.max(...Array.from(clients).map(c => c.scrollWidth + 20));
    clients.forEach((c, index) => {
        const clientWidth = c.scrollWidth + 20;
        const clonedFigures = c.innerHTML + c.innerHTML;
        var tl = new TimelineLite({ paused: true, onComplete: resetAnimation });

        if (index % 2 !== 0) {
            c.style.flexDirection = 'row-reverse';
        }

        const speedFactor = clientWidth / maxClientWidth;
        tl.set(c, { x: 0 });

        tl.to(c, 60 * speedFactor, { x: (index % 2 === 0) ? -clientWidth : clientWidth, ease: Linear.easeNone });

        function resetAnimation() {
            tl.restart();
        }

        c.innerHTML = clonedFigures;

        gsap.fromTo(
            c.querySelectorAll('figure'),
            {
                y: 80,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
                duration: 0.5,
                stagger: 0.1,
                delay: index * 1,
                scrollTrigger: {
                    trigger: c.parentElement,
                    start: 'top 70%',
                    ease: 'power4.out',
                },

            }
        );
        setTimeout(() => tl.play(), 3000);
    });
}
window.addEventListener("resize", calcHeightLine);

if (document.querySelector('.c-post__wrapper')) {
    document.querySelectorAll('.c-post__wrapper').forEach((el) => {
        if (window.innerWidth > 740) {
            if (el.querySelector('.info')) { }
            let alturaTotal = el.querySelector('.info').offsetHeight + el.querySelector('.text-bottom').offsetHeight + 32 + 16;
            let alturaWrapper = el.offsetHeight - alturaTotal;
            gsap.set(el, { height: 'auto', maxHeight: '${alturaTotal}' })
            gsap.set(el.querySelector('.c-post__content'), { marginTop: `0`, backgroundColor: 'transparent', height: 'auto', paddingTop: '24px', })
            gsap.set(el.querySelector('.c-post__title'), { paddingBottom: '24px' })
            gsap.set(el.querySelector('.hide-info'), { y: 0, height: 0, })
            gsap.set(el.querySelector('.info'), { autoAlpha: 0, })
            gsap.set(el.querySelector('.text-bottom'), { yPercent: 100 })

            let hover = gsap.timeline({ paused: true });

            hover.to(el, { height: `${alturaWrapper}`, duration: 0 })
            hover.to(el.querySelector('.c-post__content'), { backgroundColor: 'rgba(246, 246, 246, 0.70)', duration: 0.4, height: `${alturaTotal + 197 + 64}`, paddingTop: '197px', marginTop: `-=${alturaTotal + (197 - 10)}px` }, '<')
            hover.to(el.querySelector('.c-post__img'), { scale: 1.2, duration: 0.5 }, '<')
            hover.to(el.querySelector('.c-post__title'), { paddingBottom: '0', duration: 0.5 }, '<')
            hover.to(el.querySelector('.hide-info'), { transformOrigin: 'bottom', height: `${alturaTotal}`, duration: 0.5 }, '<')
            hover.to(el.querySelector('.info'), { autoAlpha: 1, duration: 0.8 }, '-=0.2')
            hover.to(el.querySelector('.text-bottom'), { yPercent: 0, duration: 0.3 }, '-=0.8')

            el.addEventListener('mouseleave', () => {
                hover.reverse()
            })
            el.addEventListener('mouseenter', () => {
                hover.play()
            })
        }
    })
}


